import { IActiveReplyMessage } from '../../types/messageReply';
import { ITypedReduxAction } from '../../types/redux/actionType';

export enum EChatWindowActionTypes {
  OpenChat = 'ChatWindow/openChat',
  CloseChat = 'ChatWindow/closeChat',
  ResetChat = 'ChatWindow/resetChat',
  IncreaseCountClosedChats = 'ChatWindow/increaseCountClosedChats',
  SetActiveReplyMessage = 'ChatWindow/setActiveReplyMessage',
  ClearActiveReplyMessage = 'ChatWindow/clearActiveReplyMessage',
}

export type TChatWindowActions =
  | ITypedReduxAction<EChatWindowActionTypes.OpenChat, string>
  | ITypedReduxAction<EChatWindowActionTypes.CloseChat>
  | ITypedReduxAction<EChatWindowActionTypes.ResetChat>
  | ITypedReduxAction<EChatWindowActionTypes.IncreaseCountClosedChats>
  | ITypedReduxAction<EChatWindowActionTypes.SetActiveReplyMessage, IActiveReplyMessage>
  | ITypedReduxAction<EChatWindowActionTypes.ClearActiveReplyMessage>;
